<template lang="pug">
footer.footer
  .content.has-text-centered
    .level
      .level-item.has-text-centered
        #social-icons
          p Follow us on social media!
          .level
            .level-item
              a(href="https://www.instagram.com/fanfairmedia/", target="_blank")
                font-awesome-icon(:icon="['fab', 'instagram']")
            .level-item
              a(href="https://www.youtube.com/user/TheShowstopper76", target="_blank")
                font-awesome-icon(:icon="['fab', 'youtube']")
            .level-item
              a(href="https://twitter.com/FanfairMedia", target="_blank")
                font-awesome-icon(:icon="['fab', 'twitter']")
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTwitter,
  faInstagram,
  faYoutube
} from "@fortawesome/free-brands-svg-icons";

library.add(faTwitter, faInstagram, faYoutube);

export default {
  name: "Footer"
};
</script>
